import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, Text } from '../../ui/index';
import { useUpdatePlanningPageVesselInfoMutation } from '../../../graphql';
import useEvent from '../../hooks/useEvent';
import { toast } from 'react-toastify';

export function ModifyVesselToFleetModal({
  onClose,
  vesselId,
  vesselName,
  type,
}: {
  onClose: () => void;
  vesselId: number | null;
  vesselName: string | null | undefined;
  type: 'add' | 'remove';
}) {
  const [updateVesselInfo, { loading }] =
    useUpdatePlanningPageVesselInfoMutation();

  const onPress = useEvent(() => {
    if (!vesselId) {
      return;
    }

    updateVesselInfo({
      variables: {
        id: vesselId,
        vessel: { externalFleet: type !== 'add' },
      },
    })
      .then(() => onClose())
      .catch(() => {
        toast.error('Failed to update vessel');
      });
  });

  if (!vesselId || !vesselName) {
    return null;
  }

  return (
    <Modal isOpen={true} onClose={onClose} width="568px" height="260px">
      <ModalBody>
        <Text fontWeight="bold">
          {type === 'add'
            ? `Add vessel ${vesselName} to own fleet`
            : `Remove vessel ${vesselName} from own fleet?`}
          <br />
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" mr="2" onPress={onClose}>
          Cancel
        </Button>
        <Button variant="negative" disabled={loading} onPress={onPress}>
          {type === 'remove' ? 'Remove' : 'Add'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
